var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaimuRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2639_30328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1019 1.44727H9.89844V12.5044H18.1019V1.44727Z",
    fill: "#FFFAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1334 6.54541H1.12012V29.8181H26.1334V6.54541Z",
    fill: "#FFFAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8931 2.18164H4.10645V30.1816H23.8931V2.18164Z",
    fill: "#FFFAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6672 5.97803H20.165V11.9657H24.6672V5.97803Z",
    fill: "#F46D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2828 7.98779H22.1006V14.3996H26.2828V7.98779Z",
    fill: "#F46D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83954 5.81836H1.86621V12.0002H7.83954V5.81836Z",
    fill: "#F46D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97345 6.54541H1.12012V14.1818H5.97345V6.54541Z",
    fill: "#F46D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8486 13.9902H1.7168V16.0021H3.8486V13.9902Z",
    fill: "#F46D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2851 14.2119H24.1533V30.0396H26.2851V14.2119Z",
    fill: "#F46D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.133 24H22.0264V31.6364H26.133V24Z",
    fill: "#F46D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1335 26.1816H20.1602V30.1816H26.1335V26.1816Z",
    fill: "#F46D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7599 28.3638H17.9199V30.182H25.7599V28.3638Z",
    fill: "#F46D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.73333 24H0V30.1818H3.73333V24Z",
    fill: "#F46D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97345 26.1816H1.12012V30.1816H5.97345V26.1816Z",
    fill: "#F46D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.84012 28H1.12012V30.1818H7.84012V28Z",
    fill: "#F46D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0722 7.98779H11.9404V9.95358H14.0722V7.98779Z",
    fill: "#F46D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1659 7.98779H16.0537V9.95358H20.1659V7.98779Z",
    fill: "#F46D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.86667 8H0V30.5455H1.86667V8Z",
    fill: "#F14B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9998 8H25.7598V30.1818H27.9998V8Z",
    fill: "#F14B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2837 30.0376H1.7168V32.0034H26.2837V30.0376Z",
    fill: "#F14B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8641 1.94141H17.752V3.9957H21.8641V1.94141Z",
    fill: "#F14B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1893 1.9873H6.07715V3.95309H10.1893V1.9873Z",
    fill: "#F14B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46645 1.81836H4.10645V4.00018H7.46645V1.81836Z",
    fill: "#F14B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.81094 3.95117H2.75488V5.97783H4.81094V3.95117Z",
    fill: "#F14B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98678 5.81836H1.12012V8.00018H2.98678V5.81836Z",
    fill: "#F14B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8932 1.81836H20.5332V4.00018H23.8932V1.81836Z",
    fill: "#F14B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3402 3.99561H23.2842V5.97801H25.3402V3.99561Z",
    fill: "#F14B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7241 5.98535H24.668V7.98801H26.7241V5.98535Z",
    fill: "#F14B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.027 0H5.97363V2.18182H22.027V0Z",
    fill: "#F14B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.477 17.5107H6.36523V18.4936H11.477V17.5107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7221 17.5107H14.6104V18.4936H19.7221V17.5107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.563 20.2178H10.4512V21.2007H15.563V20.2178Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4533 19.6885H6.27832V20.6714H9.4533V19.6885Z",
    fill: "#F4A688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8224 19.6885H16.6475V20.6714H19.8224V19.6885Z",
    fill: "#F4A688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9409 7.98779H7.94238V9.95358H11.9409V7.98779Z",
    fill: "#FEF1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0536 7.98779H14.0732V9.95358H16.0536V7.98779Z",
    fill: "#FEF1D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2639_30328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaimuRed);
export default __webpack_public_path__ + "static/media/MaimuRed.2a67a682e79915f815a48938c10389b9.svg";
export { ForwardRef as ReactComponent };